export const production = true;

export const environment = {
  production,
  APP_ID: 'careapp-web-prod',
  APP_VERSION: '1.0.0',
  API_V2_BASE_PATH: 'https://api.careapp.com.au',
  API_BASE_URL: 'https://api.careapp.com.au',
  APP_BASE_URL: 'https://app.careapp.com.au/#',
  API_VERSION: 'api/v1',
  GOOGLE_MAPS_API_KEY: 'AIzaSyBWvmTl7YRL30d-qrmKMuEPSbXssz6RHU8',
  ROLLBAR_ACCESS_TOKEN: '76c70f6830b546878a9576567872d0aa',
  ROLLBAR_ENV_NAME: 'PRODUCTION',
  STATS_TABLE_LIMIT: 5,
  httpTimeout: 10000,
  chatPollInterval: 30000,
  notificationsPollInterval: 60000,
  streamApiKey: '3xab2y6mqyh4',
  kratosFrontendUrl: 'https://accounts.careapp.com.au',
  useKratos: true,

  announcements: {
    shareToFamilyRepresentatives: false,
  },
  documents: {
    shareToFamilyRepresentatives: false,
  },
  questions: {
    shareToFamilyRepresentatives: false,
  },

  /**
   * TTL for cached objects in the store, in milliseconds
   */
  cacheTime: 1 * 60 * 60 * 1000,

  memoriam: {
    resourcesBaseUrl:
      'https://careapp-video-transcoding-memoriamresourcesbucket-8hgpcgh3tz7r.s3-ap-southeast-2.amazonaws.com',
  },

  releaseNotes: {
    feedUrl: 'https://www.careapp.com.au/category/release-notes/feed/',
  },

  firebase: {
    apiKey: 'AIzaSyBwDIVadU5AdoJ35f2fumi0gW2OEN6GJIA',
    authDomain: 'careapp-32941.firebaseapp.com',
    databaseURL: 'https://careapp-32941.firebaseio.com',
    projectId: 'careapp-32941',
    storageBucket: 'careapp-32941.appspot.com',
    messagingSenderId: '136981136015',
    appId: '1:136981136015:web:64b2be87378e59d62ba6fa',
    measurementId: 'G-M1QCTM64X9',
    remoteConfig: {
      feed_version: 2,
      memoriam_music_options: [],
      new_community_page: true,
      new_home_screen: true,
      new_workflow_gallery: true,
      new_workflow_note: true,
      show_config_list: false,
      web_archive_customer: false,
      web_access_all_customers: true,
      web_announcements_cards_on_feed: true,
      web_announcements_featuredImage: true,
      web_announcements_headline: true,
      web_announcements_new_list: true,
      web_checkin_tag: false,
      web_list_notifications: false,
      web_add_phone_number: false,
      web_configure_2fa: false,
      preferred_countries: [],
      web_phone_based_password_reset: false,
      web_provider_customer_management: false,
      web_set_email: false,
      web_self_role: false,
      web_customer_lists: false,
      web_family_representative: false,
      web_member_management: false,
    },
  },
};
